export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_08_blank.af19d01d.png";